import React, { useEffect, useState } from 'react'
import { Container, FormContainer } from './styled'
import { useParams } from 'react-router-dom'
import InternalHeader from '../../general/internalHeader/view'
import { getBookings } from 'api'
import coworking from 'assets/images/coworking.jpg'
import noAvatar from '../../../../assets/images/no-avatar.png'
import BookingForm from '../bookingForm/view';

const BookingAdmin = () => {

  const params = useParams()
  const { slug } = params
  const [,setBookings] = useState([])

  function getBookingInfo() {
    getBookings(slug).then(r => {
      setBookings(r.bookings)
    })
      .catch(console.error)
  }

  function headerActionMethod() {
  }

  useEffect(() => {
    getBookingInfo(true)
  }, [])

  const avatar = noAvatar
  return (
    <Container>
      <InternalHeader title={'New booking'} subtitle={''} avatar={avatar} background={coworking} actionTitle='Save booking' actionMethod={headerActionMethod} />
      <FormContainer>
        <BookingForm />
      </FormContainer>
    </Container>
  )
}

BookingAdmin.propTypes = {}

export default BookingAdmin
